const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const GA_ENABLE_LOCALHOST = process.env.REACT_APP_GA_ENABLE_LOCALHOST === 'true';

let isInitialized = false;
let lastTrackedPagePath = '';

const isBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined';
const isLocalhost = () =>
  isBrowser() &&
  ['localhost', '127.0.0.1', '0.0.0.0', '::1'].includes(window.location.hostname);

export const isAnalyticsEnabled = () =>
  Boolean(
    GA_MEASUREMENT_ID &&
      isBrowser() &&
      (!isLocalhost() || GA_ENABLE_LOCALHOST)
  );

export const initializeAnalytics = () => {
  if (!isAnalyticsEnabled() || isInitialized) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  const existingScript = document.querySelector(`script[data-ga-id="${GA_MEASUREMENT_ID}"]`);
  if (!existingScript) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.dataset.gaId = GA_MEASUREMENT_ID;
    document.head.appendChild(script);
  }

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false,
    anonymize_ip: true,
  });

  isInitialized = true;
};

export const trackPageView = (pagePath, pageTitle) => {
  if (!isAnalyticsEnabled() || !window.gtag) {
    return;
  }

  if (lastTrackedPagePath === pagePath) {
    return;
  }

  lastTrackedPagePath = pagePath;

  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_title: pageTitle || document.title,
    page_location: window.location.href,
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!isAnalyticsEnabled() || !window.gtag) {
    return;
  }

  window.gtag('event', eventName, params);
};
